import { z } from 'zod';
import { ErrorCode } from '../../../../shared/error-codes';
import { CreatePartnerContactRequestSchema } from '../create-partner-contact/create-partner-contact.schema';
/** Enough for a real call list, small enough for one request. */ export const PARTNER_CONTACT_IMPORT_MAX_ROWS = 1000;
/**
 * Import Partner Contacts Request
 * POST /api/v2/partner/contacts/import
 *
 * Rows that match one of the rep's contacts by `partnerContactImportKey`
 * update it; the rest are added. Importing the same file twice changes nothing.
 */ export const ImportPartnerContactsRequestSchema = z.object({
    contacts: z.array(CreatePartnerContactRequestSchema).min(1, ErrorCode.FIELD_REQUIRED).max(PARTNER_CONTACT_IMPORT_MAX_ROWS)
});
export const ImportPartnerContactsResponseSchema = z.object({
    created: z.number(),
    updated: z.number()
});

//# sourceMappingURL=import-partner-contacts.schema.js.map